import React, { Component } from 'react';
import DataFetcher from '../utils/DataFetcher';
import HomePage from '../components/HomePage';
import iconDevice from '../medias/device.svg';
import iconPacket from '../medias/packet.svg';
import iconSite from '../medias/site.svg';

class HomeOfDelegate extends Component {
  constructor(props) {
    super(props)

    this.state = {
      delegateId: this.props.delegateId
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.delegateId !== this.props.delegateId) {
        this.setState({
            delegateId: nextProps.delegateId
        }, () => {
            this.refresh()
        })
    }
  }

  render() {
    const pageProps = {
      fetchSites: (params, callback) => {
        DataFetcher.delegateSites(
          {
            ...params,
            delegateId: this.state.delegateId
          },
          {
            success: callback
          }
        )
      },
      fetchDeviceTypes: (params, callback) => {
        DataFetcher.deviceTypes(
          {
            ...params,
            delegateId: this.delegateId
          }, 
          {
            success: callback
          }
        )
      },
      agentStatistic: (params, callback) => {
        DataFetcher.delegateAgentStatistic(
          {
            ...params,
            delegateId: this.state.delegateId
          }, 
          {
            success: callback
          }
        )
      },
      siteStatistic: (params, callback) => {
        DataFetcher.delegateSiteStatistic(
          {
            ...params,
            delegateId: this.state.delegateId
          }, 
          {
            success: callback
          }
        )
      },
      deviceRevenueLink: (record) => {
        return `/delegate/${this.state.delegateId}/device_revenue/${record.siteId}`
      },
      bindRefreshFunc: (func) => {
        this.refresh = func
      },
      menuData: [
        { name: '设备管理', icon: iconDevice, link: `/delegate/device/${this.state.delegateId}` },
        { name: '套餐设置', icon: iconPacket, link: `/delegate/packet/${this.state.delegateId}` },
        { name: '门店管理', icon: iconSite, link: `/delegate/site/${this.state.delegateId}`, style: {width: 35} },
      ]
    }

    return <HomePage {...pageProps}/>
  }
}

export default HomeOfDelegate;


// WEBPACK FOOTER //
// ./src/modules/HomeOfDelegate.js